import { render } from "./Maintenance.vue?vue&type=template&id=93a08022"
const script = {}

import exportComponent from "D:\\Code Backup\\ts-web-old\\TatSingGroup-Web\\ts-logistics-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__